<template>
  <!-- 热血盲盒管理-随机盒子配置-添加配置弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加配置' : '编辑配置'"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="type" label="房间类型">
          <el-select
            style="width: 140px"
            v-model="dataForm.type"
            placeholder="请选择房间类型"
          >
            <el-option label="免费紫色" :value="1"></el-option>
            <el-option label="免费红色" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="nums" label="房间人数">
          <el-select
            style="width: 140px"
            v-model="dataForm.nums"
            placeholder="请选择房间人数"
          >
            <el-option label="双人" :value="2"></el-option>
            <el-option label="三人" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="winType" label="房间模式">
          <el-select
            style="width: 140px"
            v-model="dataForm.winType"
            placeholder="请选择房间模式"
          >
            <el-option label="欧皇" :value="1"></el-option>
            <el-option label="非酋" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="room_name" label="房间名称">
          <el-input placeholder="请输入房间名称" v-model="dataForm.room_name">
          </el-input>
        </el-form-item>
        <el-form-item prop="rand_nums" label="出现个数">
          <el-input placeholder="请输入出现个数" v-model="dataForm.rand_nums">
          </el-input>
        </el-form-item>
        <el-form-item prop="box_list" label="房间箱子id">
          <el-input placeholder="请输入房间箱子id" v-model="dataForm.box_list">
          </el-input>
        </el-form-item>
        <el-form-item prop="price" label="加入房间费用">
          <el-input placeholder="请输入房间费用" v-model="dataForm.price">
          </el-input>
        </el-form-item>
        <el-form-item label="用户等级范围">
          <el-input
            placeholder="最低等级"
            v-model="dataForm.min_level"
            style="width: 100px"
          >
          </el-input>
          -
          <el-input
            placeholder="最高等级"
            v-model="dataForm.max_level"
            style="width: 100px"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="limit_start_time" label="充值时间段">
          <el-date-picker
            v-model="dataForm.limit_start_time"
            type="date"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="dataForm.limit_end_time"
            type="date"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="limit_cycle" label="金额日期">
          <el-select
            style="width: 140px"
            v-model="dataForm.limit_cycle"
            placeholder="请选择金额日期"
          >
            <el-option label="今日" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="limit_recharge_money" label="充值金额">
          <el-input
            placeholder="请输入充值金额"
            v-model="dataForm.limit_recharge_money"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="battle_water" label="热血盲盒流水">
          <el-input
            placeholder="请输入热血盲盒流水"
            v-model="dataForm.battle_water"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="limit_nums" label="今日限制次数">
          <el-input
            placeholder="请输入今日限制次数"
            v-model="dataForm.limit_nums"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="status" label="配置状态">
          <el-select
            style="width: 140px"
            v-model="dataForm.status"
            placeholder="请选择配置状态"
          >
            <el-option label="正常" :value="1"></el-option>
            <el-option label="关闭" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//数据
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        type: '',//房间类型
        nums: '',//房间人数
        winType: 1,//房间模式 1欧皇 2非酋
        room_name: '免费活动房间',//房间名称
        rand_nums: '',//出现个数
        box_list: '',//房间箱子
        price: '',//加入房间费用
        min_level: '',//加入房间费用
        max_level: '',//加入房间费用
        limit_start_time: '',//充值开始时间
        limit_end_time: '',//充值结束时间
        limit_cycle: 1,//金额日期  默认今日1
        limit_recharge_money: '',//充值金额
        battle_water: '',//热血盲盒金额
        limit_nums: 0,//今日限制次数
        status: 2,//配置状态 1是正常  2关闭
      },
      replyRules: {//回复弹窗规则验证
        type: [
          {
            required: true,
            message: '请选择房间类型',
            trigger: 'blur'
          }
        ],
        nums: [
          {
            required: true,
            message: '请选择房间人数',
            trigger: 'blur'
          }
        ],
        winType: [
          {
            required: true,
            message: '请选择房间模式',
            trigger: 'blur'
          }
        ],
        room_name: [
          {
            required: true,
            message: '请输入房间名称',
            trigger: 'blur'
          }
        ],
        rand_nums: [
          {
            required: true,
            message: '请输入出现个数',
            trigger: 'blur'
          }
        ],
        box_list: [
          {
            required: true,
            message: '请输入房间箱子id',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
        if (!this.dataForm.room_name) {
          this.dataForm.room_name = '免费活动房间'
        }
      } else if (val && !this.fromInfo) {
        this.dataForm = {
          type: '',//房间类型
          nums: '',//房间人数
          winType: 1,//房间模式
          room_name: '免费活动房间',//房间名称
          rand_nums: '',//出现个数
          box_list: '',//房间箱子
          price: '',//加入房间费用
          min_level: '',//加入房间费用
          max_level: '',//加入房间费用
          limit_start_time: '',//充值开始时间
          limit_end_time: '',//充值结束时间
          limit_cycle: 1,//金额日期
          limit_recharge_money: '',//充值金额
          battle_water: '',//热血盲盒金额
          limit_nums: 0,//今日限制次数
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.box_list.indexOf('，') != -1) {
            this.$message.error("箱子id中包含了中文逗号")
            return
          }

          this.buttonLoading = true
          let params = this.dataForm

          if (this.type === 1) {
            postApiData('battle_room', params).then(res => {
              this.$message.success("添加成功")
              this.$emit('refresh')
              this.closeDialog()
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.type === 2) {
            patchApiData(`battle_room/${this.dataForm.id}`, params).then(res => {
              this.$message.success("编辑成功")
              this.$emit('refresh')
              this.closeDialog()
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>